export const STATE_NAME = 'USER';

export const PREFIX = `${STATE_NAME}_`;

export const UPDATE_FILTERS = PREFIX + 'UPDATE_FILTERS';

export const UPDATE_DETAIL_FILTERS = PREFIX + 'UPDATE_DETAIL_FILTERS';

export const RESET_DETAIL_FILTERS = PREFIX + 'RESET_DETAIL_FILTERS';

export const UPDATE_TRASACTION_FILTERS = PREFIX + 'UPDATE_TRASACTION_FILTERS';
